module.exports = __webpack_public_path__ + "img/Popup_Akteure2.baa33335.png";